import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';

@Injectable({
  providedIn: 'root'
})
export class ToastrHelperService {
  private translation = inject(TranslationService);
  private toastr = inject(ToastrService);

  showSuccessMessage(message: string) {
    this.showToast('success', message);
  }

  showErrorMessage(message: string) {
    this.showToast('error', message);
  }

  showWarningMessage(message: string) {
    this.showToast('warning', message);
  }

  showAddEditSuccessMessage(entity: string, isUpdate: boolean = false) {
    this.successToastMessage(entity, isUpdate ? 'COMMON.UPDATED' : 'COMMON.CREATED');
  }

  showSavedSuccessMessage(entity: string) {
    this.successToastMessage(entity, 'COMMON.SAVED');
  }

  showDeletedSuccessMessage(entity: string) {
    this.successToastMessage(entity, 'COMMON.DELETED');
  }

  showCustomSuccessMessage(entity: string, status: string) {
    this.successToastMessage(entity, status);
  }

  private successToastMessage(entity: string, status: string) {
    this.showToast('success', this.translation.instant('COMMON.ENTITY_STATUS', {
      entity: this.translation.instant(entity),
      status: this.translation.instant(status)
    }));
  }

  private showToast(type: 'success' | 'error' | 'warning' | 'info', message: string, title?: string) {
    this.toastr[type](this.translation.instant(message), title);
  }
}